import React, { useEffect } from 'react';
import { io } from 'socket.io-client';








const API_BASE_URL = "https://church-backend-48tj.onrender.com";

function MinistriesPage() {

const [ministries, setMinistries] = React.useState([]);
const [expandedMinistry, setExpandedMinistry] = React.useState(null);



 useEffect(() => {
    // socket live adds
    const socket = io(API_BASE_URL, { transports: ['websocket'] });
    socket.on('connect', () => { /* connected */ });
    socket.on('getministry', (prod) => { if (prod) setMinistries(prev => [prod, ...prev]); });
      socket.on('updateministry', (prod) => { if (prod) setMinistries(prev => [prod, ...prev]); });
    
socket.on('deleteministry', (id) => {
   setMinistries(prev =>
      prev.filter(item => item._id !== id)
   );
});


    return () => socket.disconnect();
  }, []);

  
    const getMinistries = async () => {
    try {
        const response = await fetch(`${API_BASE_URL}/api/ministries`);

        if (!response.ok) {
            throw new Error("Failed to fetch ministries");
        }

        const data = await response.json();

        setMinistries(data);

    } catch (err) {
        console.error(err);
    }
};

useEffect(() => {
    getMinistries();
}, []);


  return (
    <div className="page-shell">
      <section className="hero-banner hero-banner--compact" style={{ backgroundImage: 'url(https://images.unsplash.com/photo-1511497584788-876760111969?auto=format&fit=crop&w=1600&q=80)' }}>
        <div className="hero-overlay" />
        <div className="hero-content container">
          
          <h1>Our ministries.</h1>
          <p>Each ministry is designed to support growth, belonging, and practical service.</p>
        </div>
      </section>





<section className="ministries-showcase ">

    <div className="showcase-heading">

        <span>EXPLORE OUR MINISTRIES</span>

        <h2>

            There Is A Ministry
            For Every Season
            Of Life.

        </h2>

    </div>

    {ministries.map((item,index)=>(

        <section
            key={item.title}
            className={`ministry-feature ${index%2===0?"":"reverse"}`}
        >

            <div className="feature-image">

                <img
                    src={item.image}
                    alt={item.title}
                />

            </div>

            <div className="feature-copy">

                <span>{item.subtitle}</span>

                <h3>{item.title}</h3>

             <p
  className={
    expandedMinistry === item._id
      ? "story-text expanded"
      : "story-text"
  }
>
  {item.description}
</p>

{item.description && item.description.length > 100 && (
  <button
    className="read-more-btn"
    onClick={() =>
      setExpandedMinistry(
        expandedMinistry === item._id
          ? null
          : item._id
      )
    }
  >
    {expandedMinistry === item._id
      ? "Show Less"
      : "Read More"}
  </button>
)}
            </div>

        </section>

    ))}

</section>



    </div>
  );
}

export default MinistriesPage;
